import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { selectIsActionsBlocked } from 'containers/app/appSlice';
import { Invoices } from 'containers/index';
import { useAppSelector } from 'hooks';
import { FC } from 'react';

const InvoicesPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Invoices" />;
  }
  return <Invoices />;
};

export default InvoicesPage;
